import { useSetRecoilState } from "recoil"

import { ConsoleLogger } from "../util/logger"
import { AppStatus, ErrorCode } from "../constants/enums"
import { showsErrorMessageAtom, showsSelector } from "../recoil/atoms/shows"
import { useTranslation } from "react-i18next"

const logger = new ConsoleLogger() 

type useShowEventsCBProps = {
  onShowsMessage: (resp: any) => void
  onShowsError: (errorData: any) => void
}

export const useShowEventsCB = (): useShowEventsCBProps => {
  const { t } = useTranslation()
  const setShows = useSetRecoilState(showsSelector)
  const setShowsError = useSetRecoilState(showsErrorMessageAtom)

  /** Handle on show message from the server */ 
  const onShowsMessage =  (showsData) => { 
    logger.log('showsdata', showsData)
    setShows(showsData)
  }

  /** Handle error message from shows socket connections   */
  const onShowsError = errorData => {
    logger.log("onShowsError ===> ", errorData, AppStatus.SERVER_ERROR)
    
    // Three know type of error
    // - Invalid domain
    // - Operation not available
    // - Socket disconnect
    if (errorData.code === AppStatus.SERVER_ERROR) {
      let error = null

      switch (errorData.error.code) {
        // Handle invalid domain error
        case ErrorCode.InvalidDomain:
          error = {
            title: t("Invalid Domain!"),
            message: t("Invalid Domain Message")
          }
          break

        // Handle invalid operation error - occur if admin set show gird to No
        case ErrorCode.InvalidOperation:
          error = {
            title: t("Operation Unavailable"),
            message: t("Operation Unavailable Message")
          }
          break

        // If some other error occur
        default:
          error = {
            title: t("Oops, An Error Occurred"),
            message: t("Something Went Wrong Message")
          }
      }
      setShowsError(error)
    }
  }

  return {
    onShowsMessage,
    onShowsError
  }
}
